export default "__VITE_ASSET__DpqncORN__"